<mat-drawer-container class="container">
    <mat-drawer #drawer (openedChange)="onOpenedChange($event)" class="sidenav" mode="push" opened>
        <p class="drawer-title">{{strings["dataValidation"]}}</p>
        <p class="drawer-subtitle">{{selectedDataValidationSolutionDisplay}}</p>
        <app-virtualized-date-list
            [dates]="dataServiceDates"
            [selectedDate]="selectedDataValidationDate"
            [ariaLabel]="strings['dataValidation']"
            (dateSelected)="selectDate($event)">
        </app-virtualized-date-list>
    </mat-drawer>

    <div class="sidenav-content">
        <button mat-button class="sidenav-toggle-open" (click)="drawer.toggle()">
            <img src="../../assets/images/icons/FillchevronRight.svg" [ngClass]="{ 'chevron-left': isDrawerOpen==false, 'chevron-right': isDrawerOpen==true }">
        </button>

        <div *ngIf="noDataValidation" class="noValidation">{{strings["noDataValidation"]}}</div>
        <mat-tab-group animationDuration="0ms" #tabs class="run-data-tables" *ngIf="hasData"  mat-stretch-tabs="false" dynamicHeight (focusChange)="selectDataValidationName($event)">
            <mat-tab *ngFor="let tablename of tableNames">
                <ng-template mat-tab-label>
                  {{tablename}}
                </ng-template >
                <ng-template class="tab-content" matTabContent>
                    <app-tabulator-table *ngIf="selectedDataValidationDate" [integrationName]="selectedDataValidationSolution" [tableName]="selectedDataValidationName" [processDate]="selectedDataValidationDate">
                    </app-tabulator-table>
                </ng-template>
            </mat-tab>
        </mat-tab-group>
    </div>
</mat-drawer-container>
